import { PrimaryNavKey } from './primary-nav-key';

export class PrimaryNavOption {
  get url() {
    return `/ams/${this.routerLink}`;
  }

  constructor(
    public key: PrimaryNavKey,
    public routerLink: string,
    public text: string,
    public enabled: boolean
  ) {}
}
